module.exports = "/assets/data/0556de707bc2b56c78ba223d70035e41-DD3.data.json";